<template>
  <div class="row ad-contract-content">
    <div
      class="columns large-4 medium-4 hide-for-small-only ad-contract-content__toc-wrapper"
    >
      <ul class="ad-contract-content__toc">
        <li
          v-for="section of sections"
          :key="section.id"
          class="ad-contract-content__toc-item"
          :class="{
            'ad-contract-content__toc-item--active': section.isActive,
          }"
          @click="scroll(section.elem)"
        >
          {{ section.title }}
        </li>
      </ul>
    </div>
    <Scrollable
      class="columns large-8 medium-8 small-12 ad-contract-content__contract-wrapper"
      @scroll="checkForActiveSection"
    >
      <div
        ref="content"
        v-dompurify-html="contract"
        class="ad-contract-content__contract"
      />
    </Scrollable>
  </div>
</template>

<script>
import Scrollable from '@@/common/Scrollable';
export default {
  name: 'AdContractContent',
  components: { Scrollable },
  props: {
    contract: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      sections: [],
    };
  },
  mounted() {
    const sections = Array.from(
      this.$refs.content.querySelectorAll('section[id]'),
    );
    sections.forEach(section => {
      const title = section.querySelector('[data-heading]')?.innerText.trim();
      if (title) {
        this.sections.push({
          id: section.getAttribute('id'),
          title,
          isActive: false,
          elem: section,
        });
      }
    });

    if (this.sections.length) this.sections[0].isActive = true;
  },
  methods: {
    scroll(elem) {
      elem.scrollIntoView();
    },
    checkForActiveSection(parent) {
      const scrollTop = parent.scrollTop;

      for (const section of this.sections) {
        const { elem } = section;

        if (
          elem.offsetTop - 100 < scrollTop &&
          elem.clientHeight + elem.offsetTop - 100 > scrollTop
        ) {
          this.sections.forEach(sec => (sec.isActive = false));

          section.isActive = true;

          break;
        }
      }
    },
  },
};
</script>

<style lang="scss">
.ad-contract-content {
  &__toc-wrapper {
    background-color: $lb-light-gray;
    padding: $global-padding $global-padding * 2 $global-padding $global-padding;
  }

  &__toc {
    &-item {
      cursor: pointer;
      user-select: none;

      &--active {
        color: $lb-color-primary;
      }

      &:not(:last-child) {
        margin-bottom: $global-margin;
      }
    }
  }

  &__contract-wrapper {
    max-height: 500px;
  }

  &__contract {
    padding: 0 $global-padding / 2;
  }
}
</style>
